import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

function Reports() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold text-gray-900">Reports</h1>
      </div>
      
      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-600">Select a report from the sidebar to view.</p>
      </div>
    </div>
  );
}

export default Reports;